import { useEffect } from "react";

import Box from "@mui/material/Box";

import { UseGetFlag } from "../app/launchDarkly";
import { getQuerySearchList } from "../app/search/search.thunk";
import { useAppDispatch } from "../app/store/hooks";
import AllRecipeSection from "../components/searchPage/allRecipiesSection";
import SearchBar from "../components/searchPage/searchbar";
import { TextBigBold } from "../components/typography";
import styles from "./searchPage.module.css";

const SearchPage = () => {
  const dispatch = useAppDispatch();
  const { enableAlgoliaSearch, enableAdminFeatures } = UseGetFlag();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getQuerySearchList({ enableAlgoliaSearch, enableAdminFeatures, queryString: '' }))
  }, []);

  return (
    <Box className={styles.container}>
      <Box className={styles.heading_text_container}>
        <TextBigBold color="#3A3A3A" text="What are you cooking today?" />
      </Box>
      <SearchBar />
      <AllRecipeSection />
    </Box>
  );
};

export default SearchPage;